export enum eINFOS {
  SEPARATION = 'SEPARATION',
  RUNNINGMACHINE = 'RUNNINGMACHINE',
  STARTSEPARATION = 'STARTSEPARATION',
  RESET = 'RESET',
  NAMEUSER = 'NAMEUSER',
}
